/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The OrderStatusErrorModel model module.
* @module model/OrderStatusErrorModel
* @version 1.0.0
*/
export default class OrderStatusErrorModel {
    /**
    * Constructs a new <code>OrderStatusErrorModel</code>.
    * @alias module:model/OrderStatusErrorModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>OrderStatusErrorModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/OrderStatusErrorModel} obj Optional instance to populate.
    * @return {module:model/OrderStatusErrorModel} The populated <code>OrderStatusErrorModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderStatusErrorModel();
                        
            
            if (data.hasOwnProperty('Category')) {
                obj['Category'] = ApiClient.convertToType(data['Category'], 'String');
            }
            if (data.hasOwnProperty('Code')) {
                obj['Code'] = ApiClient.convertToType(data['Code'], 'String');
            }
            if (data.hasOwnProperty('Field')) {
                obj['Field'] = ApiClient.convertToType(data['Field'], 'String');
            }
            if (data.hasOwnProperty('Detail')) {
                obj['Detail'] = ApiClient.convertToType(data['Detail'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {String} Category
    */
    'Category' = undefined;
    /**
    * @member {String} Code
    */
    'Code' = undefined;
    /**
    * @member {String} Field
    */
    'Field' = undefined;
    /**
    * @member {String} Detail
    */
    'Detail' = undefined;




}
